import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3kwvjmx4: FaireBrandEntity = {
  token: "b_3kwvjmx4",
  type: "brand",
  name: "Block Shop",
  avatarUrl:
    "https://cdn.faire.com/fastly/f29b1610f115fdfa4af64894df2a41575b235e92291d8b1e3ebbe6020b4433cf.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9af83745eb77dd3195ddba002dab822d4e9cf6b9652df83fcf515a0c2d90b4db.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f29b1610f115fdfa4af64894df2a41575b235e92291d8b1e3ebbe6020b4433cf.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9af83745eb77dd3195ddba002dab822d4e9cf6b9652df83fcf515a0c2d90b4db.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Exuberant, hand-crafted textiles. Thoughtfully made. Sister run. Based in Los Angeles, California.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:46.039Z",
    importedBy: "entity-db-cli",
  },
};
